import { useEffect, useState } from "react";
import { Button } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
} from "recharts";
import Select from "react-select";
import moment from "moment";
import React from 'react';

function composeRandomArray(arrays) {
  const composedArray = [];
  for (const array of arrays) {
    const randomValue = array[Math.floor(Math.random() * array.length)];
    composedArray.push(randomValue);
  }
  return composedArray;
}

const COLORS = [
  "#ff4d4f",
  "#120338",
  "#0958d9",
  "#f5222d",
  "#87e8de",
  "#0958d9",
  "#120338",
  "#13c2c2",
  "#4096ff",
  "#b37feb",
  "#08979c",
  "#001d66",
  "#5c0011",
  "#391085",
  "#002329",
  "#002c8c",
  "#f5222d",
  "#391085",
  "#00474f",
  "#4096ff",
  "#531dab",
  "#00474f",
  "#0958d9",
  "#5c0011",
  "#531dab",
  "#87e8de",
  "#a8071a",
  "#391085",
  "#08979c",
  "#003eb3",
  "#820014",
  "#b37feb",
  "#08979c",
  "#a8071a",
  "#9254de",
  "#002329",
  "#001d66",
  "#9254de",
  "#5cdbd3",
  "#69b1ff",
  "#a8071a",
  "#722ed1",
  "#003eb3",
  "#ffa39e",
  "#13c2c2",
  "#69b1ff",
  "#f5222d",
  "#b37feb",
  "#5cdbd3",
  "#1677ff",
  "#ff7875",
  "#b5f5ec",
  "#bae0ff",
  "#f5222d",
  "#d3adf7",
  "#002329",
  "#bae0ff",
  "#820014",
  "#722ed1",
  "#00474f",
  "#001d66",
  "#b5f5ec",
  "#001d66",
  "#a8071a",
  "#722ed1",
  "#002329",
  "#e6f4ff",
  "#5c0011",
  "#13c2c2",
  "#1677ff",
  "#d3adf7",
  "#36cfc9",
  "#820014",
  "#120338",
  "#002c8c",
  "#ffccc7",
  "#22075e",
  "#08979c",
];
const CustomLineChart = ({
  data,
  title,
  yLabelTitle,
  keyPassed,
  columns,
  highlightValue,
  dateFormat,
}) => {
  console.log("COLUMNS Scatter Chart", columns);
  // const [activeFilters, setActiveFilters] = useState<string[]>(columns);
  const [activeFilters, setActiveFilters] = useState([]);

  const [scatterChartData, setScatterChartData] = useState(data);
  const [selectFilters, setSelectFilters] = useState([
    { value: "All", label: "All" }, // Add the "All" option
    ...columns
      .filter((dataKey) => dataKey !== keyPassed)
      .map((filter) => ({
        value: filter,
        label: filter,
      })),
  ]);

  useEffect(() => {
    if (keyPassed === "name") {
      const formattedData = data.map((item) => {
        if (
          dateFormat === undefined ||
          dateFormat === null ||
          dateFormat === ""
        ) {
          return item;
        }
        return {
          ...item,
          name: moment(item.name).format(dateFormat),
        };
      });
      setScatterChartData(formattedData);
    } else {
      const formattedData = data.map((item) => {
        if (
          dateFormat === undefined ||
          dateFormat === null ||
          dateFormat === ""
        ) {
          // return item;
          return {
            ...item,
            date: moment(item.date).format("hh:mm:ss"),
          };
        }
        return {
          ...item,
          // date: moment(item.date).format(dateFormat),
          date: moment(item.date).format("hh:mm:ss a"),
        };
      });
      setScatterChartData(formattedData);
    }

    // Set active filters to all columns initially
    setActiveFilters(columns.filter((dataKey) => dataKey !== keyPassed));
  }, []);

  const handleFilterClick = (filter) => {
    if (activeFilters.includes(filter)) {
      setActiveFilters(activeFilters.filter((item) => item !== filter));
    } else {
      setActiveFilters([...activeFilters, filter]);
    }
  };

  const handleSelectFilterChange = (selectedOptions) => {
    const selectedFilters = selectedOptions.map((option) => option.value);
    if (selectedFilters.includes("All")) {
      setActiveFilters(columns.filter((dataKey) => dataKey !== keyPassed));
    } else {
      setActiveFilters(selectedFilters.filter((filter) => filter !== "All"));
    }
  };

  const isUsingSelect = columns.length > 4;

  // const filteredData = scatterChartData.filter((item) => {
  //   console.log("scatterChartData====", scatterChartData);
  //   console.log(
  //     "Filtered Data======",
  //     activeFilters.every((filter) => item[filter])
  //   );
  //   return activeFilters.every((filter) => item[filter]);
  // });
  const filteredData = scatterChartData.filter((item) =>
    activeFilters.some((filter) => item[filter])
  );

  const formatXAxisLabel = (value, index) => {
    if (index === 0) {
      const [date, month, year] = value.split("-");
      return `${month} ${date} ${year}`;
    }
    return `${value.split("-")[1]} ${value.split("-")[0]}`;
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      console.log(active, payload);
      const { value, dataKey } = payload[0];
      const shouldShowTooltip = activeFilters.every((filter) =>
        dataKey.includes(filter)
      );

      if (shouldShowTooltip) {
        return (
          <div className="custom-tooltip">
            <p>{`Value: ${value}`}</p>
          </div>
        );
      }
    }

    return null;
  };

  console.log(CustomTooltip);

  return (
    <div
      className="stackedChartDiv"
      style={{ height: "600px", width: "1200px" }}
    >
      <div className="justifyRowSpaceBetween">
        <h4>{title}</h4>
        <div className="scatterChartDivCss">
          {isUsingSelect ? (
            <Select
              value={selectFilters.filter((option) =>
                activeFilters.includes(option.value)
              )}
              options={selectFilters}
              onChange={handleSelectFilterChange}
              isMulti
            />
          ) : (
            columns
              .filter((dataKey) => dataKey !== keyPassed)
              .map((filter, index) => {
                const isActive = activeFilters.includes(filter);
                return (
                  <Button
                    key={index}
                    onClick={() => handleFilterClick(filter)}
                    style={{
                      backgroundColor: isActive ? COLORS[index] : "white",
                      color: isActive ? "white" : COLORS[index],
                      border: `1px solid ${COLORS[index]}`,
                      marginRight: 10,
                    }}
                  >
                    {filter}
                  </Button>
                );
              })
          )}
        </div>
      </div>
      <ResponsiveContainer width="100%" height="90%">
        <LineChart
          // width={1000}
          // height={800}
          data={filteredData}
          margin={{
            top: 15,
            right: 10,
            left: 10,
            bottom: 40,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={keyPassed} fontSizeAdjust="true" />

          <YAxis
            label={{
              value: yLabelTitle,
              angle: -90,
              textAnchor: "middle",
              style: { fontWeight: "bold", fontSize: 12 },
              dx: -15,
            }}
          />

          <Tooltip />
          <Brush />
          {columns
            .filter((dataKey) => dataKey !== keyPassed)
            .map((filter, index) => {
              return (
                <Line
                  key={index}
                  type="linear"
                  dot={false}
                  dataKey={filter}
                  stroke={COLORS[index]}
                  strokeWidth={
                    activeFilters.length === 0 || activeFilters.includes(filter)
                      ? filter === highlightValue
                        ? 8
                        : 2
                      : 0
                  }
                />
              );
            })}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomLineChart;
